export default __webpack_public_path__ + "74144fec126175b7db2b082c2648d67e.png";